import {AuthenticateService} from '../../services/authenticate.service';

export function SessionRestoreFactory(auth: AuthenticateService) {
  return () => auth.loadOnStartData();
}
